import { render, staticRenderFns } from "./ExerciseAssignment.vue?vue&type=template&id=cf63e612&"
import script from "./ExerciseAssignment.vue?vue&type=script&lang=ts&"
export * from "./ExerciseAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./ExerciseAssignment.vue?vue&type=style&index=0&id=cf63e612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports